<template>
    <NuxtLayout>
        <NuxtPage :transition="{ name: 'fade', mode: 'out-in' }" />
    </NuxtLayout>
    <CookieConsent />
</template>
